import { render } from "./HeartSpecificSectionDetails.vue?vue&type=template&id=038c64d5&scoped=true"
import script from "./HeartSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./HeartSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./HeartSpecificSectionDetails.vue?vue&type=style&index=0&id=038c64d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c64d5"],['__file',"src/components/HeartSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "038c64d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('038c64d5', __exports__)) {
    api.reload('038c64d5', __exports__)
  }
  
  module.hot.accept("./HeartSpecificSectionDetails.vue?vue&type=template&id=038c64d5&scoped=true", () => {
    api.rerender('038c64d5', render)
  })

}


export default __exports__